export const css = {
    root: '_348qZ5xy',
    loading: '_3ynLTLRo',
    titleBlock: '_1CstLTLz',
    title: 'XdtF1dco',
    gotitBlock: 'EtOG_YWR',
    gotit: 'qSJrjeuR',
    section: '_2MKwsm_3',
    hero: '_1OSjZNEr',
    heroBanner: '_29dHCI9m',
    heroSubtitle: '_3CNEF5q7',
    heroIconList: '_37onpext',
    heroContent: '_2--VDTC0',
    accordion: '_1_oTgmLZ',
    verticalAccordion: '_3R14HIUd',
    horizontalAccordion: '_2dzzkQlg',
    accordionTab: '_3gKPBfKJ',
    accordionPane: '_3Zj1D5PF',
    storyline: '_2VgxGa8k',
    longDescription: '_3qZg5h59',
    figure: '_11qomP3E',
    xref: 'PRMAaLE5',
    term: '_3wYFh8Gu',
    HCBullet: '_1VoEAn_N',
    HCBulletStyle2: '_1L2RQkGX',
    TableUL: '_1xQLvWHJ',
    tableheading1: '_3hyWqPT4',
    alignLeft: '_1dv22CH1',
    alignCenter: '-u40_o_h',
    alignRight: '_3s1V0dYa',
    rowSeparator: '_3ox5sa_e',
    noRowSeparator: '_3wKHeDJ9',
    columnSeparator: '_3WQTi70-',
    noColumnSeparator: '_3KZvAPTy',
    HCHeading1Table: '_1iDds-QY',
    HCTextTable: '_2zNuLKQE',
    HCTextTableCentered: '_1OeSMF_4',
    HCTextTableFR: '_12ZNJ30d',
    HCHeading1TableLeft: '_2fYuWTu-',
    HCHeadingTableWhite: 'F-u4TQag',
    key_content: '_5S4vl22v',
    keyContent: '_2bckY2fy',
    ph: '_1I027erz',
    nextprev: '_2U7EBxsp',
    next: 'AccllqBl',
    previous: '_2YWix_RU',
    ' _key': 'book-widgets/topicpage'
};
export default css;
